import { InfoField } from "$components/info-field";
import { SearchField } from "$components/search-field";
import { SortBySelect } from "$routes/inventory/_lib/sort-by-select";
import { Box, Grid } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import useSortByOptions, {
  type StockTakeSortOption,
} from "./use-sort-by-options";

interface Props {
  locationName?: string;
  onUpdate?: () => void;
  searchTerm?: string;
  setSearchTerm?: (val: string | null) => void;
  orderBy?: StockTakeSortOption;
  setOrderBy?: (val: StockTakeSortOption) => void;
}

const OngoingStockTakeSearchFields: React.FunctionComponent<Props> = ({
  locationName,
  searchTerm,
  setSearchTerm,
  orderBy,
  setOrderBy,
}) => {
  const { formatMessage } = useIntl();
  const sortByOptions = useSortByOptions();

  return (
    <Box marginBottom={2}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <InfoField
            id="stockTakeLocation"
            fullWidth
            value={locationName}
            label={formatMessage({
              id: "inventory.stockTake.table.columnLabel.location",
              defaultMessage: "Location",
            })}
          />
        </Grid>
        <Grid item xs={7}>
          <SearchField
            fullWidth
            hideHelper
            placeholder={formatMessage({
              id: "inventory.stockTake.searchBar.placeholder",
              defaultMessage: "Search Inventory",
            })}
            value={searchTerm}
            onChange={(event) => setSearchTerm?.(event.target.value)}
            onClear={() => setSearchTerm?.(null)}
            data-testid="stockTakeSearchBar"
          />
        </Grid>
        <Grid item xs={2}>
          <SortBySelect
            options={Object.values(sortByOptions)}
            value={orderBy}
            onChange={setOrderBy}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OngoingStockTakeSearchFields;
